import React from "react";
import { Container } from "./styles";
import Actions from "./Actions";
import SelectClient from "./SelectClient";
import { useSelector } from "react-redux";
import ProfileMenu from "./ProfileMenu";
import Notification from "./Notification/index";

const RightPanel = (props) => {
  const { loading } = props;
  const selectedClient = useSelector((state) => state.clients.selectedClient);

  return (
    <div style={{ display: "flex", flexGrow: 2, justifyContent: "flex-end" }}>
      <Actions />
      <SelectClient loading={loading} />
      <Notification />
      <ProfileMenu />
    </div>
  );
};

export default RightPanel;
